import { useEffect, useState } from 'react';

import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { StyledContainer, StyledInput } from './MoneyInput.styled';

interface IMoneyInputProps extends React.HTMLAttributes<HTMLDivElement> {
	value?: number;
	readonly?: boolean;
	changeHandler?: any;
	currency?: Currency;
	noinvert?: boolean;
	placeholder?: string;
}

const MoneyInput: React.FC<IMoneyInputProps> = ({
	value,
	readonly,
	changeHandler,
	currency = Currency.Ruble,
	noinvert,
	placeholder,
}: IMoneyInputProps) => {
	const [inputValue, setInputValue] = useState<number>(value || 0);

	const currencyIcon = useWalletIcon(currency, true);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length === 0) {
			setInputValue(0);
			if (changeHandler) {
				changeHandler(0);
			}
			return;
		}

		setInputValue(parseInt(inputValue));
		if (changeHandler) {
			changeHandler(parseInt(inputValue));
		}
	};

	useEffect(() => {
		setInputValue(value ?? 0);
	}, [value]);

	return (
		<StyledContainer onMouseEnter={() => playSound(Sound.LinkCursor)}>
			<StyledInput
				readOnly={readonly}
				$readonly={readonly}
				onChange={onChange}
				value={inputValue ? inputValue.toLocaleString('ru-RU') : ''}
				$noinvert={noinvert}
				placeholder={placeholder}
				tabIndex={-1}
			/>
			<CurrencyIcon icon={currencyIcon} size="lg" />
		</StyledContainer>
	);
};

export { MoneyInput };
